import { Icon } from '@iconify/react';
import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import cameraFill from '@iconify/icons-eva/camera-fill';
// material
import { Container, Stack, Typography, Card, Box, Avatar, Grid, TextField, IconButton, Divider } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Page from '../components/Page';
import api from '../api';
import account from '../_mocks_/account';
import config from '../config.json';

// ----------------------------------------------------------------------

export default function Profile() {
  const [user, setUser] = useState({
    fullName: api.getUserFullName() || '',
    phone: api.getUserPhone() || '',
    id: api.getUserId() || '',
    activeDays: api.getUserActiveDays() || 0,
    user_avatar: api.getUserAvatar() || null,
  });

 

  useEffect(() => {
    refreshUserData();
    
  }, []);

  const refreshUserData = () => {
    api.updateUserData().then(() => {
        setUser({
            fullName: api.getUserFullName() || '',
            phone: api.getUserPhone() || '',
            id: api.getUserId() || '',
            activeDays: api.getUserActiveDays() || 0,
            user_avatar: api.getUserAvatar() || null,
        });
        // Update form values
        formik.setValues({
            fullName: api.getUserFullName() || '',
        });
    });
  }

  const handleImageUpload = (event) => {
      const file = event.target.files[0];
      if (file) {
          const formData = new FormData();
          formData.append('avatar', file); 
          api.uploadAvatar(formData).then((response) => {
              if (response.success) {
                  //refresh page 
                  window.location.reload();
              } else {
                  alert("Failed to update avatar");
              }
          });
      }
  };

  const ProfileSchema = Yup.object().shape({
    fullName: Yup.string()
      .min(2, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Full name required'),
  });

  const formik = useFormik({
    initialValues: {
      fullName: user.fullName || '',
    },
    enableReinitialize: true,
    validationSchema: ProfileSchema,
    onSubmit: async (values) => {
      const response = await api.updateProfile({ user_full_name: values.fullName });
      if (response.success) {
          refreshUserData();
          alert("Profile updated successfully");
      } else {
          alert("Failed to update profile");
      }
    }
  });

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

  return (
    <Page title="Profile | Eagles.uz">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Profile
          </Typography>
        </Stack>
        
        <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
                <Card sx={{ py: 10, px: 3, textAlign: 'center' }}>
                    <Box sx={{ mb: 3, mx: 'auto', display: 'flex', justifyContent: 'center', position: 'relative', width: 128, height: 128 }}>
                        <Avatar 
                            src={user.user_avatar ? user.user_avatar : '/static/mock-images/avatars/avatar_default.jpg'}
                            alt={user.fullName}
                            sx={{ width: '100%', height: '100%' }} 
                        />
                         <Box
                            sx={{
                                position: 'absolute',
                                bottom: 0,
                                right: 0,
                                zIndex: 9,
                            }}
                        >
                             <input
                                accept="image/*"
                                style={{ display: 'none' }}
                                id="icon-button-file"
                                type="file"
                                onChange={handleImageUpload}
                            />
                            <label htmlFor="icon-button-file">
                                <IconButton color="primary" aria-label="upload picture" component="span" sx={{ bgcolor: 'background.paper', boxShadow: 1, '&:hover': { bgcolor: 'grey.200' } }}>
                                    <Icon icon={cameraFill} />
                                </IconButton>
                            </label>
                        </Box>
                    </Box>
                    <Typography variant="h3">{user.fullName}</Typography>
                    <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                        {user.phone}
                    </Typography>
                </Card>
            </Grid>

            <Grid item xs={12} md={8}>
                 <Card sx={{ p: 3 }}>
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={3}>
                                <Stack direction="row" justifyContent="space-between" alignItems="center">
                                    <Typography variant="subtitle1">User ID</Typography>
                                    <Typography variant="body1">{user.id}</Typography>
                                </Stack>
                                <Divider />
                                <Stack direction="row" justifyContent="space-between" alignItems="center">
                                     <Typography variant="subtitle1">Phone Number</Typography>
                                     <Typography variant="body1">{user.phone}</Typography>
                                </Stack>
                                <Divider />
                                <Stack direction="row" justifyContent="space-between" alignItems="center">
                                     <Typography variant="subtitle1">Active Days</Typography>
                                     <Typography variant="body1">{user.activeDays}</Typography>
                                </Stack>
                                <Divider />
                                
                                <TextField
                                    fullWidth
                                    label="Full Name"
                                    {...getFieldProps('fullName')}
                                    error={Boolean(touched.fullName && errors.fullName)}
                                    helperText={touched.fullName && errors.fullName}
                                />

                                <LoadingButton
                                    fullWidth
                                    size="large"
                                    type="submit"
                                    variant="contained"
                                    loading={isSubmitting}
                                >
                                    Save Changes
                                </LoadingButton>
                            </Stack>
                        </Form>
                    </FormikProvider>
                 </Card>
            </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
